export const overviewSubtitles = [
  ['MRR residential', 'MRR commercial'],
  ['MRR residential', 'MRR commercial'],
  ['Pending MRR residential', 'Pending MRR commercial'],
  ['Residential', 'Commercial', 'New conenctions last month', 'New conenctions current month', 'Total pending connections', 'New pending current month'],
  ['New lead-ings current month'],
  ['Residential', 'Commercial', 'Mixed'],
  ['ARPU residential', 'ARPU commercial'],
  ['Uptake residential', 'Uptake commercial'],
  ['Canceled', 'Awaiting Cancelation', 'Suspended', 'Awaiting Suspension'],
  ['Canceled', 'Awaiting Cancelation', 'Suspended', 'Awaiting Suspension'],
  ['Canceled', 'Awaiting Cancelation', 'Suspended', 'Awaiting Suspension']
]
